angular.module('rightPaneModule')
  .directive("iaplPane", function() {
    return {
      restrict: "E",
      scope: {
        itemReady: '=',
        title: '@',
        viewMode: '@',
        lessonGroupExpandStyle: '@',
        groupByDomain: '@',
        includeAssignFocus: '@',
        showControls: '@',
        showDomainCount: '@',
        showLessonGroupDescription: '@',
        showLessonGroupStudents: '@'
      },
      templateUrl: '/resources/right-pane/partials/iapl-pane.html',
      link : function(scope, $elem, $attr) {
         scope.view.viewMode = $attr.viewMode;
         scope.view.includeAssignFocusActivities = $attr.includeAssignFocus === 'true';
         scope.view.groupByDomain = $attr.groupByDomain === 'true';
      },
      controller: ['$scope', 'configuration', 'dblIaplService', 'dblLessonService', 'translateFilter', function($scope, $configuration, dblIaplService, dblLessonService, translateFilter) {
        $scope.pdLocations = {};
        $scope.analyticsCategory = 'Lesson Group Preview';
        $scope.isMyFlexPDTransitionFeatureFlagEnabled = $configuration.isFeatureEnabled('myflexpd_transition');
        $scope.view = {
          viewMode: 'classroom',
          includeAssignFocusActivities: false,
          groupByDomain: false
        };

        $scope.selectedRow = {
          name: null,
          students: null
        };

        var initializeData = function() {
          $scope.loadingPage = true;

          var filters = {
            includeAssignFocusActivities: $scope.view.includeAssignFocusActivities,
            viewMode: $scope.view.viewMode // 'classroom' vs 'student'
          };

          dblIaplService.getLists(filters)
            .then(function(data) {
              updateLists(data.lessonGroups, data.studentLessonGroups);
              $scope.reportDates = data.reportDates;
              expandFirstRow();
            }).finally(function() {
              $scope.loadingPage = false;
            });
        };

        // grab af choice and call service
        function logIaplEvent(action, event) {
          dblIaplService.logEvent(action, event, $scope.view.includeAssignFocusActivities);
        }

        function updateLists(lessonGroups, studentLessonGroups) {
          $scope.lessonGroups = lessonGroups;
          $scope.studentLessonGroups = studentLessonGroups;
          $scope.domains = sortByCount(transformDataShape($scope.lessonGroups, $scope.view.groupByDomain));
        }

        function sortByCount(domains) {
          var sortedDomains = _.sortBy(domains, function(domain) {
            return -domain.count; //order by .count desc
          });
          _.forEach(sortedDomains, function(domain, key) {
            domain.lessonGroups = _.sortBy(domain.lessonGroups, function(lessonGroup){
              return -lessonGroup.count;
            });
          });
          return sortedDomains;
        }

        function transformDataShape(lessonGroups, groupByDomain) {
          if (groupByDomain) {
            var domains = {}; //aggregate on domain's name

            _.forEach(lessonGroups, function(lessonGroup, key) {
              var domain = domains[lessonGroup.domain];
              if (domain === undefined) {
                domain = {
                  studentIds: {},
                  count: 0,
                  lessonGroups: [],
                  name: lessonGroup.domain
                };
                domains[lessonGroup.domain] = domain;
              }
              _.merge(domain.studentIds, lessonGroup.studentIds);
              domain.lessonGroups.push(lessonGroup);
              domain.count = _.size(domain.studentIds);
            });

            return _.reject(_.values(domains), function(d) {
              return d.count === 0; // domain may have zero students when AssignFocus is not checked
            });
          }
          else {
            // wrapped in a dummy domain
            return [{
              lessonGroups: lessonGroups
            }];
          }
        }

        function expandFirstRow() {
          if ($scope.domains && $scope.domains.length > 0 &&
            $scope.domains[0].lessonGroups &&
              $scope.domains[0].lessonGroups.length > 0) {

            var lgName = $scope.domains[0].lessonGroups[0].name;
            $scope.selectedRow.name = lgName;
            $scope.selectedRow.students = dblIaplService.getStudents(lgName, $scope.view.includeAssignFocusActivities);
          }
        }

        function getAllLessonGroupNames(lessonGroups, studentLessonGroups) {
          var lessonGroupNames = [];
          var lessonGroupsArray = [lessonGroups, studentLessonGroups];
          _.forEach(lessonGroupsArray, function(lessonGroups, key) {
            _.forEach(lessonGroups, function(lessonGroup, key) {
              lessonGroupNames.push(lessonGroup.name);
            });
          });
          return lessonGroupNames.join();
        }

        function refresh(eventMessage) {
          var filters = {
            includeAssignFocusActivities: $scope.view.includeAssignFocusActivities
          };
          var data = dblIaplService.filterActivities(filters);
          updateLists(data.lessonGroups, data.studentLessonGroups);
          expandFirstRow();

          logIaplEvent(eventMessage, null, $scope.view.includeAssignFocusActivities);
        }

        $scope.toggleGroupByDomain = function() {
          refresh('Toggle Group By Domain');
        };

        $scope.toggleAssignFocus = function() {
          refresh('Toggle Assigned Focus');
        };

        $scope.getPdUrl = function(item) {
          var url = null;
          if (item && item.name) {
            url = $scope.pdLocations[item.name];
          }
          return url;
        };

        $scope.getLessonImage = function(item) {
          if (!item.standards) {
            return '';
          }

          return dblLessonService.getImageForDblStandard(item.name);
        };

        $scope.gotoStandard = function(standard, lessonGroup) {
          if (standard) {
            logIaplEvent('Select Standard', {
              label: lessonGroup.name + ', ' + standard.name
            }, $scope.view.includeAssignFocusActivities);
          }
        };

        $scope.getDemoLessonUrl = function(demoLessonName) {
          return dblLessonService.getDemoLink(demoLessonName);
        };

        $scope.getDemoDetails = function(lessonGroup) {
          // when the view is on student level, AF is always included.
          return dblIaplService.getDemoDetails(lessonGroup, $scope.view.viewMode === 'student' ? null : $scope.view.includeAssignFocusActivities);
        };

        $scope.handleRowClick = function(item) {
          if ($scope.selectedRow.name === item.name) {
            $scope.selectedRow.name = null;
            $scope.selectedRow.students = null;
          }
          else {
            $scope.selectedRow.name = item.name;
            $scope.selectedRow.students = dblIaplService.getStudents(item.name, $scope.view.includeAssignFocusActivities);
            logIaplEvent('Expand Lesson Group', {
              label: item.name
            }, $scope.view.includeAssignFocusActivities);
          }
        };

        $scope.translateCurriculumText = function(text, maxLength) {
          var translatedShortDescription = translateFilter('curriculumData.' + text, {defaultValue: text});
          if (maxLength && maxLength > -1 && translatedShortDescription.length > maxLength) {
            return translatedShortDescription.substring(0, maxLength) + '...';
          }
          return translatedShortDescription;
        };

        $scope.$watch('itemReady', function(newVal) {
          if (newVal) {
            if ($scope.view.viewMode === 'student') {
              $scope.currentStudentId = newVal.id;
            }
            initializeData();
          }
        });
      }]
    };
  }).filter('fullName', function() {
    return function(student) {
      return student.first_name + ' ' + student.last_name;
    };
  });
